module.exports = __webpack_public_path__ + "img/37.3781a9f3.jpg";